
import Trontron from "../../../assets/duotone/Trontron.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function TrontronIcon({ className, dataTestid = "TrontronIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Trontron data-testid={dataTestid} className={classes} {...rest} />
  );
}
